import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getCompositeProducts = createAsyncThunk(
  "CompositeProduct/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.ITEM.SLUG}/composite?${queryString}`
      );
      // const product_list = data.data.list;
      // return { product_list };
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// export const getActiveProduct = createAsyncThunk(
//   "ActiveProduct/get",
//   async (_, { rejectWithValue }) => {
//     try {
//       const { data } = await axios.get(API_URL.ITEM.ACTIVE_ITEMS);
//       return data;
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );

export const createCompositeProduct = createAsyncThunk(
  "CompositeProduct/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.ITEM.SLUG}/composite`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const updateCompositeProduct = createAsyncThunk(
  "CompositeProduct/update",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM.SLUG}/composite`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getCompositeProductOverview = createAsyncThunk(
  "CompositeProductOverview/get",
  async (itemId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.ITEM.SLUG}/${itemId}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateStatusCompositeProduct = createAsyncThunk(
  "UpdateCompositeProductStatus/put",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM.SLUG}/UpdateStatus/${id}`
      );
      dispatch(getCompositeProductOverview(id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const discontinuedCompositeProduct = createAsyncThunk(
  "CompositeProductDiscontinued/put",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM.SLUG}/Discontinue`,
        payload
      );
      dispatch(getCompositeProductOverview(payload?.itemId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteCompositeProduct = createAsyncThunk(
  "CompositeProduct/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.ITEM.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const compositeProductSlice = createSlice({
  name: "compositeProducts",
  initialState: {
    composite_products_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    single_product_data: { modalOpen: false, id: null },
    composite_product_overview: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
      state.composite_products_list = [];
    },
    setSingleProductData(state, action) {
      state.single_product_data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompositeProducts.fulfilled, (state, action) => {
        state.composite_products_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getCompositeProductOverview.fulfilled, (state, action) => {
        state.composite_product_overview = action.payload;
      });
  },
});

export const {
  setCurrentValues,
  setActivePayload,
  resetCurrentValue,
  setSingleProductData,
} = compositeProductSlice.actions;
export default compositeProductSlice.reducer;
